import { useState } from "react";
import { DropResult } from "@hello-pangea/dnd";

import { TabItem } from "../types";

const useTabDragAndDrop = (
  dynamicTabs: TabItem[] | undefined,
  onReorder?: (newOrder: TabItem[]) => void,
) => {
  const [isDragging, setIsDragging] = useState(false);
  const [draggingIndex, setDraggingIndex] = useState<number>(0);

  const handleDragStart = (e: { source: { index: number } }) => {
    setIsDragging(true);
    setDraggingIndex(e.source.index);
  };

  const handleDragEnd = async (result: DropResult) => {
    setIsDragging(false);

    if (!result.destination || result.destination.index === result.source.index) {
      return;
    }

    const sourceIndex = result.source.index;
    const destinationIndex = result.destination.index;

    if (!dynamicTabs) {
      return;
    }

    const updatedTabs = [...dynamicTabs];
    const [movedTab] = updatedTabs.splice(sourceIndex, 1);
    updatedTabs.splice(destinationIndex, 0, movedTab);

    if (onReorder) {
      onReorder(updatedTabs);
    }
  };

  return {
    isDragging,
    draggingIndex,
    handleDragStart,
    handleDragEnd,
  };
};

export default useTabDragAndDrop;
